var app = require('./app')

app.value('Session', {})
